import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getBadge as getBadgeApi,
    createBadge as createBadgeApi,
    updateBadge as updateBadgeApi,
    deleteBadge as deleteBadgeApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getBadge = createAsyncThunk("Badge/getBadge", async () => {
    try {
        const response = await getBadgeApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const createBadge = createAsyncThunk("Badge/createBadge", async (badge: any) => {
    try {
        const response = createBadgeApi(badge);
        const data = await response;
        toast.success("Badge Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Badge Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateBadge = createAsyncThunk("Badge/updateBadge", async (dataArr: any) => {
    try {
        const response = updateBadgeApi(dataArr);
        const data = await response;
        toast.success("Badge Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Badge Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteBadge = createAsyncThunk("Badge/deleteBadge", async (badgeId: any) => {
    try {
        const response = deleteBadgeApi(badgeId);
        console.log(response);
        toast.success("Badge Deleted Successfully", { autoClose: 2000 });
        return badgeId;
    } catch (error) {
        toast.error("Badge Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
